<template>
  <div id="func-55">
    <FuncionalidadeHeader :titulo="funcParametros.dashboard.nome" :voltar="!isWidget"/>
    <template v-if="isWidget">
      <div style="padding: 20px">
        <el-row>
          <date-blocks-vertical
            :show-pagination="false"
            :show-more-button="true"
          >
            <template v-slot:actions="item">
              <acoes-utilizacao
                :row="dataExtrato(item.selected)"
              />
            </template>
          </date-blocks-vertical>
        </el-row>
      </div>
    </template>
    <template v-else>
      <div v-html="estilosDinamicos"></div>
      <div style="padding: 0 20px">
        <el-row>
          <el-col :span="15">

            <el-row style="margin-bottom: 25px">
              <div style="padding-top:15px">
                <el-row class="func-55-item" :style="`${estiloLinha}; border-radius: 10px`">
                  <el-col :span="8" class="text-right">
                    <el-button
                      type="text"
                      :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}!important`"
                      v-if="!customLabel"
                      @click="selecionaMes('prev')"
                    >
                      <i class="el-icon-arrow-left"></i>
                    </el-button>
                  </el-col>
                  <el-col :span="!customLabel ? 8 : 24" class="text-center">
                    <h2
                      class="func-55-title-headers"
                      :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}; margin-top:2px;`"
                      v-if="!customLabel"
                    >
                      {{ mesSelecionado.label }}  {{ mesSelecionado.year }}
                    </h2>
                    <div v-else>
                      <h4
                        class="func-55-title-headers"
                        :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`"
                      >
                        Periodo personalizado
                      </h4>
                      <span class="sub" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`">
                      <b>{{ mesSelecionado.label }}</b>
                    </span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <el-button
                      type="text"
                      :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}!important`"
                      :disabled="mesSelecionado.value == mesAtual ? true : false"
                      v-if="!customLabel"
                      @click="selecionaMes('next')"
                    >
                      <i class="el-icon-arrow-right" style="font-size: 16px; font-weight: bold;"></i>
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </el-row>

            <el-row style="margin-bottom: 15px">
              <el-alert
                :title="data.alerta"
                v-if="refreshData"
                ref="alertError"
                type="warning">
              </el-alert>
            </el-row>

            <el-row>
              <div>
                <el-row class="func-55-item">
                  <el-col :span="20">
                    <h2 class="func-55-title" v-if="funcParametros.visualizarTotalgeral">{{ funcParametros.labelTotilizador }}</h2>
                    <span class="sub">Período: {{ parseDate(data.dataInicioPeriodoApuracao) }} a {{ parseDate(data.dataFimPeriodoApuracao) }}</span>
                  </el-col>
                  <el-col :span="4" class="text-right" v-if="funcParametros.visualizarTotalgeral">
                    <h2 class="func-55-title" v-html="parseValor(data.valorTotalExtrato)"></h2>
                  </el-col>
                </el-row>
              </div>
            </el-row>

            <el-row v-if="extratos && extratos.length > 0">

              <ul
                class="func-listagens"
                v-if="tipoAgrupamentoRegistros === 1"
              >
                <li
                  v-for="(extrato, index) in extratos"
                  :key="index"
                  :name="index"
                  class="func-55-li"
                >
                  <el-row class="func-55-item" style="background: #F6F6F6; border-radius: 10px">
                    <el-col :span="20">
                      <h2 class="func-55-title">{{ extrato.nomeBeneficiario }}</h2>
                      <span class="sub">{{ extrato.tipoUsuario }}</span>
                    </el-col>
                    <el-col :span="4" class="text-right">
                      <h2 class="func-55-title" v-html="parseValor(extrato.valorTotalPorTipoServico)" v-if="funcParametros.visualizarValorPorGrupo"></h2>
                    </el-col>
                  </el-row>

                  <div class="listagem-status">

                    <ul
                      class="func-listagens"
                      style="padding: 0 20px"
                    >
                      <li
                        v-for="(procedimento, index) in extrato.procedimentos"
                        :key="index"
                        :name="index"
                        class="func-55-li"
                        @click="showDetalhe(procedimento)"
                      >
                        <el-row style="cursor:pointer">
                          <el-col :span="18">
                            <h2 class="func-55-title">{{ procedimento.descricaoProcedimento}}</h2>
                            <span class="sub"><b>{{ parseDate(procedimento.dataAtendimento) }}</b></span>  <span class="sub" style="margin-left:25px">Guia: {{ procedimento.numeroGuia }} </span><br/>
                            <span class="sub">{{ procedimento.localAtendimento }}</span>
                          </el-col>
                          <el-col :span="4" class="text-right">
                            <h2 class="func-55-title" v-html="parseValor(procedimento.valorServico)" v-if="funcParametros.visualizarValorPorItem"></h2>
                          </el-col>
                          <el-col :span="funcParametros.visualizarValorPorItem ? 2 : 6" class="text-right">
                            <i
                              class="el-icon-arrow-right"
                              :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}!important`"
                            ></i>
                          </el-col>
                        </el-row>
                      </li>
                    </ul>

                  </div>
                </li>
              </ul>

              <ul
                class="func-listagens"
                v-else-if="tipoAgrupamentoRegistros === 2"
              >
                <li
                  v-for="(extrato, index) in extratos"
                  :key="index"
                  :name="index"
                  class="func-55-li"
                >
                  <el-row class="func-55-item" style="background: #F6F6F6; border-radius: 10px;">
                    <el-col :span="20">
                      <h2 class="func-55-title">{{ extrato.tipoServico }}</h2>
                      <span class="sub"></span>
                    </el-col>
                    <el-col :span="4" class="text-right">
                      <h2 class="func-55-title" v-html="parseValor(extrato.valorTotalPorTipoServico)" v-if="funcParametros.visualizarValorPorGrupo"></h2>
                    </el-col>
                  </el-row>

                  <div class="listagem-status">

                    <ul
                      class="func-listagens"
                      style="padding: 0 20px"
                    >
                      <li
                        v-for="(procedimento, index) in extrato.procedimentos"
                        :key="index"
                        :name="index"
                        class="func-55-li"
                        @click="showDetalhe(procedimento)"
                      >
                        <el-row style="cursor:pointer">
                          <el-col :span="18">
                            <h2 class="func-55-title">{{ procedimento.descricaoProcedimento}}</h2>
                            <span class="sub"><b>{{ parseDate(procedimento.dataAtendimento) }}</b></span>  <span class="sub" style="margin-left:25px">Guia: {{ procedimento.numeroGuia }} </span><br/>
                            <span class="sub">{{ procedimento.localAtendimento }}</span><br/>
                            <span class="sub">{{ procedimento.nomeBeneficiario }}</span>
                          </el-col>
                          <el-col :span="4" class="text-right">
                            <h2 class="func-55-title" v-html="parseValor(procedimento.valorServico)" v-if="funcParametros.visualizarValorPorItem"></h2>
                          </el-col>
                          <el-col :span="funcParametros.visualizarValorPorItem ? 2 : 6" class="text-right">
                            <i class="el-icon-arrow-right"></i>
                          </el-col>
                        </el-row>
                      </li>
                    </ul>

                  </div>
                </li>
              </ul>

            </el-row>
            <el-row v-else-if="extratos && extratos.length === 0">
              <ErrorVazio
                :titulo="errorVazio.titulo"
                :texto="errorVazio.texto"
                :showBtn="false"/>
            </el-row>

            <el-row v-if="!extratos && reqError">
              <ErrorCarregar />
            </el-row>
          </el-col>

          <el-col :span="9">

            <div class="line"></div>
            <div style="margin: 0 15px 0 25px">
              <el-row class="func-55-item">
                <el-col :span="24">
                  <h2 class="func-55-title-headers">Histórico de Utilização</h2>
                </el-col>
              </el-row>

              <el-row class="func-55-item">
                <date-blocks-vertical
                  :month-history="mesesHistorico"
                  :show-pagination="false"
                  @selectedItem="getList($event.mesDate)"
                />
              </el-row>

              <el-row class="func-55-item">
                <el-col :span="24">
                  <el-date-picker
                    :style="`cursor:pointer;
                  border-radius: 6px;
                  ${estiloLinha};`"
                    v-model="dateRange"
                    type="daterange"
                    start-placeholder=" Selecionar período..."
                    range-separator=""
                    format="dd/MM/yyyy"
                    @change="getList(dateRange, true)"
                    popper-class="custom-datepicker"
                    end-placeholder="">
                    <p slot="range-separator" class="el-range-separator" v-if="dateRange && dateRange.length">a</p>
                  </el-date-picker>
                </el-col>
              </el-row>
              <el-row class="func-55-item">
                <MenuVertical :columns="actionsList"/>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <DialogDefault
          title="Detalhes do Serviço"
          :open.sync="showDialog"
          width="40%"
          :closeOnClickModal="false"
          v-if="procedimentoDetalhe"
        >
          <Func55Detalhe :procedimento="procedimentoDetalhe" :funcParametros="funcParametros"></Func55Detalhe>
        </DialogDefault>
      </div>
    </template>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ErrorCarregar from '@/components/Error/ErrorCarregar'
import ErrorVazio from '@/components/Error/ErrorVazio'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import Func55Detalhe from './Func55Detalhe'
import DateBlocksVertical from '@/components/Listagem/dateBlocksVertical'
import AcoesUtilizacao from '@/views/55/AcoesUtilizacao'
import MenuVertical from '@/components/MenuVertical/MenuVertical.vue'

export default {
  name: 'Func55ExtratoUtilizacao',
  components: {
    MenuVertical,
    AcoesUtilizacao,
    DateBlocksVertical,
    FuncionalidadeHeader,
    ErrorCarregar,
    ErrorVazio,
    DialogDefault,
    Func55Detalhe
  },
  data () {
    return {
      data: { valorTotalExtrato: null },
      dateRange: [],
      reqError: true,
      refreshData: true,
      customLabel: false,
      showDialog: false,
      procedimentoDetalhe: null,
      errorVazio: {
        titulo: 'Nenhuma utilização encontrada!',
        texto: 'Não localizamos nenhuma utilização no periodo informado.'
      },
      extratos: [],
      collapseds: [],
      mesesHistorico: [],
      columns: [
        { field: 'nomeBeneficiario' },
        { field: 'valorServico', html: this.parseValor }
      ],
      filter: {
        dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
        dataFinal: moment().endOf('month').format('YYYY-MM-DD')
      },
      mesAtual: moment().format('YYYY-MM-DD'),
      mesSelecionado: {}
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem', 'isWidget']),
    ...mapGetters('Login', ['user']),
    estiloLinha () {
      return `background: ${this.estilo.aplicacao.corPrimariaAplicacao}0d !important`
    },
    classeCorPrimariaIcone () {
      return `color: ${this.estilo.aplicacao.corPrimariaAplicacao} !important`
    },
    estilosDinamicos () {
      return `<style>
      .el-date-table td.available :hover {
        color: ${this.estilo.aplicacao.corPrimariaAplicacao};
      }
      .el-date-table td.today span {
        color: ${this.estilo.aplicacao.corPrimariaAplicacao};
      }
      .el-date-table td.in-range div, .el-date-table td.in-range div:hover {
        background-color: ${this.estilo.aplicacao.corPrimariaAplicacao}0d;
      }
      .el-date-table td.end-date span, .el-date-table td.start-date span {
        background-color: ${this.estilo.aplicacao.corPrimariaAplicacao};
        color: white !important;
      }
     .el-icon-date  {
        color: ${this.estilo.aplicacao.corPrimariaAplicacao} !important;
      }
      </style>`
    },
    funcParametros () {
      return this.funcionalidade.parametros
    },
    tipoAgrupamentoRegistros () {
      return this.funcionalidade.parametros.tipoAgrupamentoRegistros
    },
    exibeExtratoPdf () {
      return this.funcionalidade.parametros.exibeExtratoPDF
    },
    actionsList () {
      return [
        {
          title: 'Salvar',
          action: this.loadPdf,
          show: this.exibeExtratoPdf
        }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    parseValor: function (valor) {
      return `R$ ${Math.floor(valor)},<span>${(valor - Math.floor(valor)).toFixed(2).split('.')[1]}</span>`
    },
    parseDate: function (value) {
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    async init () {
      this.mesSelecionado.value = this.mesAtual
      this.mesSelecionado.label = this.formatMounth(this.mesSelecionado.value)
      this.mesSelecionado.year = this.getYear(this.mesSelecionado.value)

      if (!this.isWidget) {
        this.getMesesHistorico()
        await this.getList()
      }
    },
    agruparPorBeneficiario () {
      const result = this.data.extrato.reduce(function (r, a) {
        r[a.chaveUnica] = r[a.chaveUnica] || []
        r[a.chaveUnica].push(a)
        return r
      }, Object.create(null))

      for (const key in result) {
        const mappedData = { ...result[key] }

        const extrato = {
          nomeBeneficiario: mappedData[0].nomeBeneficiario,
          idTipoUsuario: mappedData[0].idTipoUsuario,
          valorTotalPorTipoServico: 0,
          procedimentos: Object.keys(mappedData).map(key => mappedData[key])
        }

        switch (extrato.idTipoUsuario) {
          case 'T':
            extrato.tipoUsuario = 'Titular'
            break
          case 'D':
            extrato.tipoUsuario = 'Dependente'
            break
          case 'A':
            extrato.tipoUsuario = 'Agregado'
            break
        }

        extrato.procedimentos.map(proc => {
          let quantidade = proc.quantidade ? proc.quantidade : 1
          let valorServico = proc.valorServico * quantidade
          proc.tipoUsuario = extrato.tipoUsuario
          extrato.valorTotalPorTipoServico += valorServico
        })

        this.data.valorTotalExtrato += extrato.valorTotalPorTipoServico
        this.extratos.push(extrato)
      }
    },
    agruparPorServico () {
      const result = this.data.extrato.reduce(function (r, a) {
        r[a.idTipoServico] = r[a.idTipoServico] || []
        r[a.idTipoServico].push(a)
        return r
      }, Object.create(null))

      for (const key in result) {
        const mappedData = { ...result[key] }

        const extrato = {
          tipoServico: mappedData[0].descricaoTipoServico,
          valorTotalPorTipoServico: 0,
          procedimentos: Object.keys(mappedData).map(key => mappedData[key])
        }

        extrato.procedimentos.map(proc => {
          let quantidade = proc.quantidade ? proc.quantidade : 1
          let valorServico = proc.valorServico * quantidade
          extrato.valorTotalPorTipoServico += valorServico
        })

        this.data.valorTotalExtrato += extrato.valorTotalPorTipoServico
        this.extratos.push(extrato)
      }
    },
    async getList (filtro, custom = null) {
      this.refreshData = false
      this.customLabel = false

      if (filtro && custom) {
        this.customLabel = true
        this.filter.dataInicial = moment(filtro[0]).format('YYYY-MM-DD')
        this.filter.dataFinal = moment(filtro[1]).format('YYYY-MM-DD')

        let dataInicialLabel = moment(filtro[0]).format('DD/MM/YYYY')
        let dataFinalLabel = moment(filtro[1]).format('DD/MM/YYYY')

        this.mesSelecionado.label = `${dataInicialLabel} a ${dataFinalLabel}`
        this.mesSelecionado.value = filtro[0] || this.mesAtual
      } else {
        filtro = filtro || this.mesAtual
        this.filter.dataInicial = moment(filtro).startOf('month').format('YYYY-MM-DD')
        this.filter.dataFinal = moment(filtro).endOf('month').format('YYYY-MM-DD')
        this.dateRange = []

        this.mesSelecionado.label = this.formatMounth(filtro)
        this.mesSelecionado.value = filtro
      }
      this.mesSelecionado.year = this.getYear(this.mesSelecionado.value)

      const lista = await this.apiFuncionalidade.extrato({
        payload: this.filter,
        loading: true,
        handlerErrorIgnore: [404]
      })

      this.extratos = []
      this.data.valorTotalExtrato = 0
      this.refreshData = true
      if (lista.status) {
        this.reqError = false
        this.data = lista.data
        this.data.valorTotalExtrato = 0

        if (this.tipoAgrupamentoRegistros === 1) {
          this.agruparPorBeneficiario(this.data)
        } else if (this.tipoAgrupamentoRegistros === 2) {
          this.agruparPorServico(this.data)
        }
      } else {
        this.data.dataInicioPeriodoApuracao = moment(this.mesSelecionado.value).startOf('month').format('YYYY-MM-DD')
        this.data.dataFimPeriodoApuracao = moment(this.mesSelecionado.value).endOf('month').format('YYYY-MM-DD')
        this.reqError = true
      }
    },
    async selecionaMes (filtro) {
      let mesSelecionado = ''
      if (filtro === 'prev') {
        mesSelecionado = moment(this.mesSelecionado.value).subtract(1, 'months').format('YYYY-MM-DD')
      } else if (filtro === 'next') {
        mesSelecionado = moment(this.mesSelecionado.value).add(1, 'months').format('YYYY-MM-DD')
      }

      this.mesSelecionado.label = this.formatMounth(mesSelecionado)
      this.mesSelecionado.value = mesSelecionado
      this.mesSelecionado.year = this.getYear(mesSelecionado)

      await this.getList(mesSelecionado)
    },
    getYear (date) {
      return moment(date).format('YYYY')
    },
    formatMounth (date) {
      let mounth = moment(date).locale('pt-br').format('MMMM').toString()
      return mounth[0].toUpperCase() + mounth.slice(1)
    },
    getMesesHistorico () {
      let oldMounth = moment().format('YYYY-MM-DD')

      for (let i = 0; i < 7; i++) {
        this.mesesHistorico.push({
          ano: this.getYear(oldMounth),
          mes: this.formatMounth(oldMounth),
          mesDate: oldMounth
        })
        oldMounth = moment(oldMounth).subtract(1, 'months').format('YYYY-MM-DD')
      }
    },
    showDetalhe (procedimento) {
      this.procedimentoDetalhe = procedimento
      this.showDialog = true
    },
    dataExtrato (item) {
      return {
        'chaveUnica': this.user.chaveUnica,
        'dataInicial': moment(item.mesDate).startOf('month').format('YYYY-MM-DD'),
        'dataFinal': moment(item.mesDate).endOf('month').format('YYYY-MM-DD'),
        'descricao': `Extrato Mês ${item.mes} ${item.ano}`
      }
    },
    async loadPdf () {
      const response = await this.apiFuncionalidade.extratoPdf({
        payload: {
          dataInicial: this.filter.dataInicial,
          dataFinal: this.filter.dataFinal
        },
        loading: true,
        handlerErrorIgnore: [404]
      })
      if (response.statusCode === 200 && response.data.base64) {
        window.open(this.baseToUrl(response.data.base64), '_blank')
      }
      if (response.statusCode === 200 && response.data.url) {
        window.open(response.data.url, '_blank')
      }
      if (response.statusCode !== 200 || (!response.data.url && !response.data.base64)) {
        this.$message.error('Erro ao gerar PDF')
      }
    },
    baseToUrl (base) {
      const binaryPDF = window.atob(base)
      const byteArray = new Uint8Array(binaryPDF.length)
      for (let i = 0; i < binaryPDF.length; i++) {
        byteArray[i] = binaryPDF.charCodeAt(i)
      }
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      return URL.createObjectURL(blob)
    }
  }
}
</script>
<style scoped>

.line {
  height: 100%;
  border-right: 1px solid #EEEEEE;
  float: left;
  position: absolute;
  margin-top: -21px;
  margin-left: 20px;
}

.el-alert {
  border-radius: 10px;
}

/deep/ .el-alert__content {
  padding: 0;
  display: flex;
}

/deep/ .el-alert__title {
  line-height: 19px;
  padding-right: 30px;
}

/deep/ .el-alert__closebtn {
  top: 40% !important;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  opacity: 1;
}
</style>
